export default function Footer() {
  return (
    <footer className="bg-[#1E2430] text-white py-12 px-6">
      <div className="max-w-6xl mx-auto">
        <div className="grid md:grid-cols-3 gap-8 mb-8">
          <div>
            <h3 className="text-lg font-bold mb-4 text-[#D8B36A]" style={{ fontFamily: 'Manrope, sans-serif' }}>
              Контакты оргкомитета
            </h3>
            <div className="space-y-3 text-sm text-white/80">
              <div className="flex items-center gap-3">
                <i className="ri-mail-line text-[#D8B36A]"></i>
                <a href="mailto:info@painmed.ru" className="hover:text-[#D8B36A] transition-colors cursor-pointer">
                  info@painmed.ru
                </a>
              </div>
              <div className="flex items-center gap-3">
                <i className="ri-phone-line text-[#D8B36A]"></i>
                <a href="tel:+78126605866" className="hover:text-[#D8B36A] transition-colors cursor-pointer">
                  +7 (812) 660-58-66
                </a>
              </div>
              <div className="flex items-center gap-3">
                <i className="ri-vk-line text-[#D8B36A]"></i>
                <a href="https://vk.com/protivboli" target="_blank" rel="noopener noreferrer" className="hover:text-[#D8B36A] transition-colors cursor-pointer">
                  VK: protivboli
                </a>
              </div>
              <div className="flex items-center gap-3">
                <i className="ri-video-line text-[#D8B36A]"></i>
                <a href="https://vkvideo.ru/@protivboli" target="_blank" rel="noopener noreferrer" className="hover:text-[#D8B36A] transition-colors cursor-pointer">
                  ВК Видео: protivboli
                </a>
              </div>
              <div className="flex items-center gap-3">
                <i className="ri-youtube-line text-[#D8B36A]"></i>
                <a href="https://www.youtube.com/@%D0%A1%D0%97%D0%9E%D0%98%D0%91" target="_blank" rel="noopener noreferrer" className="hover:text-[#D8B36A] transition-colors cursor-pointer">
                  YouTube: СЗОИБ
                </a>
              </div>
            </div>
          </div>

          <div>
            <h3 className="text-lg font-bold mb-4 text-[#D8B36A]" style={{ fontFamily: 'Manrope, sans-serif' }}>
              Полезные ссылки
            </h3>
            <div className="space-y-3 text-sm text-white/80">
              <div>
                <a href="https://painmed.ru/event/vtoraya-shkola-komorbidnoj-patologii-peterburzhskie-vechera/" target="_blank" rel="noopener noreferrer" className="hover:text-[#D8B36A] transition-colors cursor-pointer flex items-center gap-2">
                  <i className="ri-file-text-line text-[#D8B36A]"></i>
                  Подробная программа
                </a>
              </div>
              <div>
                <a href="#privacy" className="hover:text-[#D8B36A] transition-colors cursor-pointer flex items-center gap-2">
                  <i className="ri-shield-check-line text-[#D8B36A]"></i>
                  Политика конфиденциальности
                </a>
              </div>
              <div>
                <a href="#consent" className="hover:text-[#D8B36A] transition-colors cursor-pointer flex items-center gap-2">
                  <i className="ri-file-shield-line text-[#D8B36A]"></i>
                  Согласие на обработку ПДн
                </a>
              </div>
            </div>
          </div>

          <div>
            <h3 className="text-lg font-bold mb-4 text-[#D8B36A]" style={{ fontFamily: 'Manrope, sans-serif' }}>
              О мероприятии
            </h3>
            <p className="text-sm text-white/80 leading-relaxed">
              Петербуржские вечера — серия очных научно-практических встреч для врачей в культурной столице России.
            </p>
          </div>
        </div>

        <div className="border-t border-white/10 pt-8 flex flex-col md:flex-row items-center justify-between gap-4 text-sm text-white/60">
          <p>© 2026 Петербуржские вечера. Все права защищены.</p>
          <a 
            href="https://painmed.ru/" 
            target="_blank" 
            rel="noopener noreferrer" 
            className="hover:text-[#D8B36A] transition-colors cursor-pointer"
          >
            Powered by Or-Love
          </a>
        </div>
      </div>
    </footer>
  );
}